import { request } from "@/api/request"

/** 转中心列表（已提交） */
export function fetchTransferCenterList(payload = {}) {
  return request.post("/mgm-crm-api/transfer-center/list", payload).then(r => r.data)
}

/** 转中心审批列表（待处理 / 已处理） */
export function fetchTransferCenterApprovalList(payload = {}) {
  return request.post("/mgm-crm-api/transfer-center/query-approval-list", payload).then(r => r.data)
}

/** 转中心详情 */
export function fetchTransferCenterDetail(id) {
  return request.get(`/mgm-crm-api/transfer-center/detail/${id}`).then(r => r.data)
}

/** 申请转中心 */
export function applyTransferCenter(payload = {}) {
  return request.post("/mgm-crm-api/transfer-center/apply", payload).then(r => r.data)
}

/** 取消申请 */
export function cancelTransferCenterApply(payload = {}) {
  return request.post("/mgm-crm-api/transfer-center/approve-cancel", payload).then(r => r.data)
}

/** 审核通过 */
export function approveTransferCenterPass(payload = {}) {
  return request.post("/mgm-crm-api/transfer-center/approve-pass", payload).then(r => r.data)
}

/** 审核驳回 */
export function approveTransferCenterReject(payload = {}) {
  return request.post("/mgm-crm-api/transfer-center/approve-reject", payload).then(r => r.data)
}

/** 查询转中心学生课包剩余课时 */
export function fetchStudentPackageRemain(payload = {}) {
  return request.post("/mgm-crm-api/transfer-center/student-package-remain", payload).then(r => r.data)
}
